import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon } from 'lucide-react';
const rangeHours = [{
  range: 'Indoor Pistol Range',
  hours: '9:00 AM – Dusk (check calendar for closures)'
}, {
  range: 'Outdoor Pistol Range',
  hours: '9:00 AM – Dusk'
}, {
  range: 'Outdoor Rifle Range',
  hours: '9:00 AM – Dusk'
}, {
  range: 'Sporting Clays',
  hours: 'See Sporting Clays schedule'
}, {
  range: 'Archery Range',
  hours: 'Dawn – Dusk'
}];
export function RangeHours() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2939">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2940">
        <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#1e3d2f'
      }} data-id="element-2941">
          Range Hours
        </h2>
        <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-2942">
          <div className="p-4 flex items-center gap-3" style={{
          backgroundColor: '#1e3d2f'
        }} data-id="element-2943">
            <ClockIcon size={20} style={{
            color: '#c8a84b'
          }} data-id="element-2944" />
            <h3 className="text-base font-bold uppercase" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-2945">
              Operating Hours
            </h3>
          </div>
          <div className="overflow-x-auto" data-id="element-2946">
            <table className="w-full text-left border-collapse" data-id="element-2947">
              <thead data-id="element-2948">
                <tr style={{
                backgroundColor: 'rgba(30,61,47,0.04)'
              }} data-id="element-2949">
                  <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                  color: '#1e3d2f',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2950">
                    Range
                  </th>
                  <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                  color: '#1e3d2f',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2951">
                    Hours
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-2952">
                {rangeHours.map((item, index) => <tr key={item.range} className={index < rangeHours.length - 1 ? 'border-b' : ''} style={{
                borderColor: '#ede9e0'
              }} data-id="element-2953">
                    <td className="p-4 font-medium text-gray-800" style={{
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2954">
                      {item.range}
                    </td>
                    <td className="p-4 text-gray-700" style={{
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2955">
                      {item.hours}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <div className="bg-gray-50 p-4 border-t" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2956">
            <p className="text-sm text-gray-500 italic" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2957">
              Always check the{' '}
              <Link to="/Calendar.html" className="font-semibold underline" style={{
              color: '#1e3d2f'
            }} data-id="element-2958">
                club calendar
              </Link>{' '}
              for closures due to events, league shoots, or police training.
            </p>
          </div>
        </div>
      </div>
    </div>;
}